import {mergeStyleSets} from "@fluentui/react";

export const useStyles = () => {
  return mergeStyleSets({
    formControl: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    label: {
      fontWeight: 600,
    }
  })
}